import { PortalTelemetryScreen } from '../../app/telemetry/portalTelemetryScreens';
import { portalScreenContext } from '../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import { VolunteeringTypeEnum } from '../../app/models/volunteering/common/volunteeringTypeEnum';
import VolunteeringForm from '../../app/models/volunteering/VolunteeringForm';

export default function AlumniVolunteeringForm() {
  usePortalScreen(portalScreenContext(PortalTelemetryScreen.AlumniVolunteeringForm));

  return (
    <VolunteeringForm type={VolunteeringTypeEnum.ALUMNI} />
  );
};
